/**
 * Verification evidence mapping.
 *
 * Backend colony steps carry an optional `evidence` payload (the
 * VerificationResult.to_dict() output). This flattens the machine-run
 * build/test checks across steps for display in the EvidencePanel.
 */

interface RawCheck {
  name: string;
  passed: boolean;
  command: string;
  output_tail: string;
}

interface RawEvidence {
  passed: boolean;
  checks: RawCheck[];
}

export interface EvidenceCheck {
  name: string;
  passed: boolean;
  command: string;
  outputTail: string;
}

export function mapEvidenceToChecks(
  nodeResults: Array<{ evidence?: RawEvidence }>,
): EvidenceCheck[] {
  return nodeResults
    .filter((n): n is { evidence: RawEvidence } => !!n.evidence)
    .reverse()
    .flatMap((n) =>
      n.evidence.checks.map((c) => ({
        name: c.name,
        passed: c.passed,
        command: c.command,
        outputTail: c.output_tail,
      })),
    );
}
